/**
 *  AenaHighlightedPoints script file
**/

import { mapActions, mapGetters } from 'vuex'
import { ACTIONS, GETTERS } from '@/store'
import { normalizeLowerCase } from '@/utils/matchString'
import setDeviceWidthClass from '@/mixins/setDeviceWidthClass'
import AenaHighlightedPointsList from './aena-highlighted-points-list/AenaHighlightedPointsList.vue'

export default {
  name: 'app-aenaHighlightedPoints',
  mixins: [setDeviceWidthClass],
  components: {
    AenaHighlightedPointsList
  },
  props: {
    highlighted: {
      type: Array,
      required: true
    },
    headerHeight: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      isMobile: GETTERS.GET_IS_MOBILE,
      airportID: GETTERS.GET_AIRPORT_ID,
      isRoute: GETTERS.IS_ROUTE_MODE,
      pois: GETTERS.GET_POIS_LIST,
      transitionPoisList: GETTERS.GET_TRANSITION_POIS_LIST,
      destinationC: GETTERS.GET_DESTINATION,
      route: GETTERS.GET_ROUTE,
      buildings: GETTERS.GET_BUILDINGS
    }),
    outdoorOptions () {
      const URL_BASE = 'https://www.google.com/maps/dir'
      const origin = ''
      let destination = ''
      if (this.destinationC) {
        const oitPointId = this.buildings.find(x => x.id === this.destinationC.properties.building).levels.find(x => x.id === this.destinationC.properties.level).oit_point
        const origin = this.transitionPoisList.find(x => x.properties.id === oitPointId)
        destination = origin.geometry.coordinates.slice(0, 2).reverse().toString()
      }

      return [
        {
          href: `${URL_BASE}/${origin}/${destination}/data=!4m2!4m1!3e0`,
          icon: 'car-t.svg',
          title: this.$t('OUTDOOR_OPTION_1'),
          subtitle: this.$t('OUTDOOR_SUB_OPTIONS')
        },
        {
          href: `${URL_BASE}/${origin}/${destination}/data=!4m2!4m1!3e3`,
          icon: 'Transporte_publico_T.svg',
          title: this.$t('OUTDOOR_OPTION_2'),
          subtitle: this.$t('OUTDOOR_SUB_OPTIONS')
        }
      ]
    },
    outdoorActived () {
      return process.env.VUE_APP_OUTDOOR === 'true' && this.isRoute && this.route.destinationName === 'origin'
    },
    outdoorDisabled () {
      return !this.destinationC
    }
  },
  methods: {
    ...mapActions([ACTIONS.LOAD_ROUTE]),
    selectPoint (category) {
      this.$emit('onSelect', { category, component: 'aena-points-categories' })

      const tag = {
        'eventCategory': 'buscador',
        'eventAction': 'punto de interes',
        'eventLabel': `${normalizeLowerCase(category.name)}`,
        'language': this.$i18n.locale,
        'airportID': this.airportID
      }
      window.digitalChange('event', tag)
    },
    allPoints () {
      this.$emit('onSelect', { component: 'aena-points-list' })
    },
    goToOutdoor (event) {
      // Find transition point from transition poi list based on a building and floor transition poi ID
      const oitPointId = this.buildings.find(x => x.id === this.destinationC.properties.building).levels.find(x => x.id === this.destinationC.properties.level).oit_point
      const origin = this.transitionPoisList.find(x => x.properties.id === oitPointId)
      if (origin) {
        origin.mode = 'point'
        origin.properties.icon = 'marcadores/pp_00-mk.svg'
        this[ACTIONS.LOAD_ROUTE]({
          origin
        })
      } else {
        // eslint-disable-next-line
        console.warn(`Destination Poi building (${this.destinationC.properties.location.name}) has no transition poi`)
      }
    }
  },
  watch: {
    isRoute: {
      immediate: true,
      handler (value) {
        if (!value) {
          if (this.$refs.mainTab) {
            this.$refs.outdoorTab.isActive = false
            this.$refs.mainTab.isActive = true
          }
        }
      }
    }
  }
}
